import { comment } from '@axo/shared/data-access/types';
import { send } from '../../lib/send';
import { IAPI } from '../../lib/models/api';

export function createComment({ url: { service: baseURL }, token }: IAPI) {
  return (comment: comment.CreateComment): Promise<comment.Comment> =>
    send({
      baseURL,
      token,
      path: `/comment`,
      method: 'POST',
      body: comment,
    });
}

export interface Comments {
  Items: comment.Comment[];
}

export function find({ url: { service: baseURL }, token }: IAPI) {
  return (params: comment.FindCommentsParams): Promise<Comments> =>
    send({
      baseURL,
      token,
      path: `/comment`,
      method: 'GET',
      searchParams: {
        id: params.ID,
        loanApplicationID: params.LoanApplicationID,
        ownerID: params.OwnerID,
        followUpAtInMinutes: params.FollowupAtInMinutes,
      },
    });
}

export function deleteComment({ url: { service: baseURL }, token }: IAPI) {
  return async (commentID: string): Promise<comment.Comment> =>
    send({
      baseURL,
      token,
      path: `/comment/${commentID}`,
      method: 'DELETE',
    });
}

export function resolveComment({ url: { service: baseURL }, token }: IAPI) {
  return async (commentID: string): Promise<comment.Comment> =>
    send({
      baseURL,
      token,
      path: `/comment/${commentID}/resolve`,
      method: 'PATCH',
    });
}

export function patchComment({ url: { service: baseURL }, token }: IAPI) {
  return async (
    patch: Pick<Partial<comment.Comment>, 'ID'>,
  ): Promise<comment.Comment> =>
    send({
      baseURL,
      token,
      path: `/comment/${patch.ID}`,
      method: 'PATCH',
      body: patch,
    });
}
